/**
 * Module-level bridge for triggering client-side toasts from outside React
 * (e.g. QueryClient MutationCache.onError which runs before providers mount).
 *
 * A consumer registers its setter via registerToastFn on mount;
 * any call to triggerToast() will forward to that setter.
 */

export type ToastSeverity = 'error' | 'warning' | 'info' | 'success';

export type ToastFn = (
  severity: ToastSeverity,
  title: string,
  message: string,
) => void;

let _toastFn: ToastFn | null = null;

export const registerToastFn = (fn: ToastFn): void => {
  _toastFn = fn;
};

export const unregisterToastFn = (): void => {
  _toastFn = null;
};

export const triggerToast = (
  severity: ToastSeverity,
  title: string,
  message: string,
): void => {
  _toastFn?.(severity, title, message);
};
